import {isNull} from "util";

/**
 * Created by claudio iozzia on 16/06/2017.
 */


export class Warning {

  static None: Warning = new Warning();
  private static severityRedAlertThreshold: number = 1E6;

  public get msg() {
    return this._msg;
  }

  public get severity() {
    return this._severity;
  }

  public constructor(private _msg: string = null, private _severity: number = 0) {
    this.reset(_msg, _severity);
  }

  reset(v: string = null, s: number = 1) {
    if (v !== this.msg || s !== this.severity) {
      this._msg = v;

      this._severity = this.isEmpty
        ? 0
        : Math.max(1, s);
    }
  }

  public get isEmpty() {
    return isNull(this.msg) || this.msg === '';
  }

  public get notEmpty() {
    return !this.isEmpty;
  }

  public get warningLevel(): string {
    return this.severity >= Warning.severityRedAlertThreshold ? "error" : "warning";
  }

}

